import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const Breadcrumb = ({ items }) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.label,
      "item": item.href ? window.location.origin + item.href : undefined
    }))
  };

  return (
    <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumb">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <ol className="flex items-center gap-1.5 text-sm text-zinc-500 flex-wrap">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-zinc-600" />}
            {i === items.length - 1 ? (
              <span className="text-zinc-300 line-clamp-1">{item.label}</span>
            ) : (
              <Link to={item.href} className="hover:text-amber-500 transition-colors">{item.label}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
